import React from 'react';
import { Box, upToMd } from '@ally/metronome-ui';
import { StyledMenuItem } from './StyledMenuComponents';
import MenuLink from './MenuLink';
export default function ContactUsButton({ routeInEmber, routeLinks, closeMenu, }) {
    return (React.createElement(Box, { mt: upToMd('lg', 'xl') },
        React.createElement(StyledMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.contact.bankUrl, text: routeLinks.contact.content, routeInEmber: routeInEmber, closeMenu: closeMenu }))));
}
//# sourceMappingURL=ContactUsButton.js.map